import React from "react";
import styles from "./NotFoundPage.module.css";
import { FaTools } from "react-icons/fa";

function NotFound() {
  return (
    <div>
      <div className={styles.notFound__page}>
        <div className={styles.notFound__card}>
          <div className={styles.notFound__title}>
            <p>404</p>
            <FaTools size="70" />
          </div>
          <div className={styles.notFound__subTitle}>PAGE NOT FOUND</div>
          <div className={styles.notFound__content}>
            <p>The requested page was not found.</p>
          </div>
        </div>
      </div>{" "}
    </div>
  );
}

export default NotFound;
